import { render, staticRenderFns } from "./HomeTablet.vue?vue&type=template&id=d0713826&"
import script from "./HomeTablet.vue?vue&type=script&lang=js&"
export * from "./HomeTablet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports